import React from 'react';
import { Route } from 'react-router-dom';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import styles from './csstransitionroute.css';

function CSSTransitionRoute({ transitionName, transitionEnterTimeout, transitionLeaveTimeout, ...rest }) {
  return (
    <Route render={({ location, match, history }) => (
      <CSSTransitionGroup
        transitionName={transitionName}
        transitionEnterTimeout={transitionEnterTimeout}
        transitionLeaveTimeout={transitionLeaveTimeout}>
        <Route location={location} key={location.key} {...rest} />
      </CSSTransitionGroup>
    )}/>
  )
}

export default CSSTransitionRoute;



// WEBPACK FOOTER //
// ./src/components/CSSTransitionRoute/CSSTransitionRoute.js